import { AppShell } from "@/components/AppShell";
import { AUSWERTUNGEN_SECTION_SUBTITLES } from "@/lib/auswertungenNav";
import { DocumentMarginsReport } from "@/pages/auswertungen/DocumentMarginsReport";

export function DocumentMarginsPage() {
  return (
    <AppShell
      title="Auswertungen"
      subtitle={AUSWERTUNGEN_SECTION_SUBTITLES["document-margins"]}
    >
      <DocumentMarginsReport />
    </AppShell>
  );
}
